export const getChallengeName = (variant: string, year: string) => {
  switch (variant) {
    case 'autumn':
      return 'Challenge Automne ' + year;
    case 'spring':
      return 'Challenge Printemps ' + year;
    default:
      return 'Bouton Challenge';
  }
};
